{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "Vai trò của bạn không cho phép {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "Vai trò của bạn không cho phép thực hiện thao tác này",
    "mustHaveAtLeast8Characters": "Phải có ít nhất 8 ký tự",
    "mustContainUpperCaseAndLowerCase": "Phải chứa chữ hoa và chữ thường",
    "mustContainAtLeastOneLetter": "Phải chứa ít nhất một chữ cái",
    "mustContainAtLeastOneSpecialCharacter": "Phải chứa ít nhất một ký tự đặc biệt",
    "mustContainAtLeastOneNumber": "Phải chứa ít nhất một chữ số"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "Mọi quyền và toàn quyền kiểm soát tất cả tài khoản.",
    "godRoleWithLessControl": "Vai trò Toàn quyền nhưng ít quyền kiểm soát hơn.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "Mọi quyền và toàn quyền kiểm soát tài khoản Tổ chức.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Tạo/chỉnh sửa/xóa Cuộc hẹn, Kho hàng, Loại hàng, Cửa kho và Người dùng (trừ Chủ sở hữu).",
    "createEditCancelAppointments": "Tạo/chỉnh sửa/hủy Cuộc hẹn.",
    "editAppointmentStatusTagsAndSubscribers": "Chỉnh sửa Trạng thái cuộc hẹn, thẻ và người nhận.",
    "viewOnlyNoCreateOrEditActionsAllowed": "Chỉ xem. Không được phép tạo hoặc chỉnh sửa.",
    "carrierAdministrator": "Quản trị viên hãng vận chuyển.",
    "carrierUser": "Người dùng hãng vận chuyển",
    "baseUserAccount": "Tài khoản người dùng cơ bản.",
    "warehouseDriverHasLimitedAccessToTheApplication": "Tài xế kho hàng, có quyền truy cập hạn chế vào ứng dụng."
  }
}
